import * as React from 'react';
import { Button, Select } from '@src/controls';
import { Field, FieldProps, Form, Formik } from 'formik';
import { FormattedMessage } from '@src/i18n';
import { CarrierProductModel } from '@src/models';
import { stylesheet } from 'typestyle';
import { connect } from 'react-redux';
import { configActions, configSelectors } from '@src/modules/config';
import { dispatchOnDraftSiteId } from '@src/utils/conditional-dispatchers';
import { RootState } from '@src/modules';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { groupPriceRuleTranslations } from '../helpers';
import { UpdatePriceRulesModel } from '@src/models';

interface OwnProps {
  regionId: string;
  ruleIndex?: number;
  product: CarrierProductModel;
  onSaveClick: () => void;
}

const mapStateToProps = (
  state: RootState,
  props: OwnProps & RouteComponentProps<{ regionId?: string }>
) => ({
  categories: configSelectors.getCategoriesWithMethodsFromRegionCarrierProducts(
    state,
    props.regionId
  ),
  region: configSelectors.getRegionById(state, props.regionId),
});

const mapDispatchToProps = () => ({
  updateCarrierProduct: dispatchOnDraftSiteId(configActions.updateCarrierProductRequest),
});

type Props = OwnProps &
  RouteComponentProps<{ regionId?: string }> &
  ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

interface FormValues {
  type?: string;
}

export const CreateGroupPriceRuleFormInternal: React.FC<Props> = ({
  regionId,
  ruleIndex,
  product,
  updateCarrierProduct,
  onSaveClick,
}) => {
  const saveChanges = (values: FormValues) => {

    const newGroupPriceRules = [
      ...(ruleIndex === undefined ? [{ type: values.type }] : []),
      ...product.groupPriceRules.map((rule, index) => index === ruleIndex ? { type: values.type } : rule),
    ].filter(rule => rule.type !== undefined)

    updateCarrierProduct({
      model: {
        regionId,
        method: product.shippingMethod,
        externalMethodId: product.externalMethodId,
        priceRules: product.priceRules as UpdatePriceRulesModel[],
        groupPriceRules: newGroupPriceRules,
        deliveryTypes: product.deliveryTypes,
      },
    });
  }

  return (
    <Formik<FormValues>
      initialValues={{
        type: ruleIndex !== undefined ? product.groupPriceRules[ruleIndex].type : undefined,
      }}
      onSubmit={values => {
        saveChanges(values);
        onSaveClick();
      }}
      isInitialValid={false}
    >
      {({ values, setFieldValue, touched, errors }) => {
        return (
          <Form>
            <div className={styles.wrapper}>
              <Field name="type">
                {({ field }: FieldProps<FormValues>) => (
                  <Select
                    options={[
                      { value: 'RULE_REDUCE_PRICE_WHEN_MORE_EXPENSIVE_PRODUCT_SELECTED', label: groupPriceRuleTranslations['RULE_REDUCE_PRICE_WHEN_MORE_EXPENSIVE_PRODUCT_SELECTED'] },
                      { value: 'RULE_DISCOUNT_ALL_BUT_MAX', label: groupPriceRuleTranslations['RULE_DISCOUNT_ALL_BUT_MAX'] },
                    ]}
                    {...field}
                    onChange={value => setFieldValue('type', value)}
                  />
                )}
              </Field>
              <Button
                className={styles.footer}
                type="primary"
                htmlType="submit"
                disabled={values.type === undefined}
              >
                <FormattedMessage id="SAVE" />
              </Button>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

const styles = stylesheet({
  wrapper: {
    minWidth: '420px',
  },
  footer: {
    marginTop: '15px',
  },
});

export const CreateGroupPriceRuleForm = withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateGroupPriceRuleFormInternal))
